import styled from '@emotion/styled';
import { helperTypographyText } from '../../helpers';
import { field } from '../../common/Input/styles';
import { Variables } from '../../common/Variables';
import { media } from '../../styles/MediaQueries';
import { Colors } from '../../common/Colors';

export const Container = styled('div')`
  .noUi-connects::after {
    background-color: transparent !important;
  }

  &:focus-within {
    .noUi-connects {
      background-color: ${Colors.ut.inputDown};
    }

    .noUi-connect {
      background-color: ${Colors.ut.primaryDimDown};
    }
  }
`;

export const Field = styled('div')`
  position: relative;
  display: flex;
  margin-top: 1.5rem;
  background-clip: padding-box;
  border-radius: ${Variables.inputRadius};
  backface-visibility: hidden;
`;

export const Label = styled('label')`
  ${helperTypographyText({ size: 'XL' })};
  overflow: hidden;
  align-self: center;
  flex-shrink: 0;
  max-width: 15rem;
  padding-left: 2rem;
  color: inherit;
  word-break: break-word;
  cursor: inherit;

  @media ${media.mobile} {
    padding-left: 1.6rem;
    max-width: 15.4rem;
  }
`;

export const Input = styled('input')`
  ${field}
  ${helperTypographyText({ size: 'XL' })};
`;
